(function () {

  if (document.getElementById('js_pricingBlock')) {

    const switcherBlock = document.getElementById('js_newPricingPage-switch');
    const switcherButtons = Array.prototype.slice.call(switcherBlock.children);

    const yearlyViews = Array.prototype.slice.call(document.getElementsByClassName('pricing-yearly'));
    const monthlyViews = Array.prototype.slice.call(document.getElementsByClassName('pricing-monthly'));

    const lifeTimeContainer = document.getElementById('js_pricingLifetimeView');
    const tempContainer = document.getElementById('js_pricingTempView');

    const productBlockSwitch = document.getElementById('js_newPricingProduct-switch');
    const productButtonsSwitch = Array.prototype.slice.call(productBlockSwitch.children);

    const tempTable = document.getElementById('js_pricingTable');

    const dataView = {
      defaultView: 'Pay yearly',
      defaultProduct: 'PRO Extension'
      // pro: {
      //   lifetime: {
      //     url: '/checkout/?offerId=754',
      //     price: 299,
      //     subtotal: 399
      //   },
      //   monthly: {
      //     url: '/checkout/?offerId=39',
      //     price: 44.99
      //   },
      //   yearly: {
      //     url: '/checkout/?offerId=756',
      //     price: 14.9,
      //     annually: 179
      //   }
      // },
      // bundle: {
      //   monthly: {
      //     url: '/checkout/?bundle=amazonsellersbundlemonth',
      //     price: 49.87,
      //     save: 123,
      //     subtotal: '172.87'
      //   },
      //   yearly: {
      //     url: '/checkout/?bundle=amazonsellersbundle',
      //     price: 24.9,
      //     annually: 299,
      //     save: 814,
      //     subtotal: '1,113'
      //   }
      // }
    }

    const hideAllTempViews = () => {
      const all = yearlyViews.concat(monthlyViews);
      all.forEach(e => {
        e.classList.add('pricingHide');
      });
    }

    const displayBlocks = (blocks) => {
      hideAllTempViews();
      containerSwitch(false);
      blocks.forEach(e => {
        e.classList.remove('pricingHide');
      });
    }

    const containerSwitch = (status) => {
      tempContainer.style.display = status ? "none" : "block";
      lifeTimeContainer.style.display = status ? "block" : "none";
    }

    const priceView = (name) => {
      switch (name) {
        case "Pay yearly":
          switcherButtons[1].classList.add('sw-active');
          displayBlocks(yearlyViews);
          break;
        case "Pay monthly":
          switcherButtons[0].classList.add('sw-active');
          displayBlocks(monthlyViews);
          break;
        case "Pay for a lifetime":
          switcherButtons[2].classList.add('sw-active');
          containerSwitch(true);
          break;
        default:
          log('Undefined view name.');
          break;
      }
    }

    priceView(dataView.defaultView)

    const tableView = (name) => {
      tempTable.className = "newPricingPage-compareBlock";
      switch (name) {
        case "PRO Extension":
          productButtonsSwitch[0].classList.add('sw-active');
          tempTable.classList.add('proBlock');
          break;
        case "Amazon Seller's Bundle":
          productButtonsSwitch[1].classList.add('sw-active');
          tempTable.classList.add('bundleBlock');
          break;
        default:
          log('Undefined product name.');
          break;
      }
    }

    tableView(dataView.defaultProduct);

    const addListeners = (block, buttons, type) => {
      block.addEventListener('click', e => {

        if (e.target.tagName === "BUTTON") {
          buttons.forEach(b => {
            b.classList.remove('sw-active');
          });
          if (type === "temp") {
            priceView(e.target.textContent)
          } else {
            tableView(e.target.textContent);
          }
        }
      });
    }

    addListeners(switcherBlock, switcherButtons, "temp");
    addListeners(productBlockSwitch, productButtonsSwitch, "table");

  }

}());
